<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-left">
        <div class="login-brand">
          <div class="brand-icon">
            <i class="el-icon-s-opportunity"></i>
          </div>
          <h1>第一届明安图天文前沿论坛</h1>
          <p>The First Minggatu Forum on Astronomy Frontier</p>
        </div>
        <div class="login-features">
          <div class="feature-item">
            <i class="el-icon-star-on"></i>
            <span>探索宇宙奥秘</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-user"></i>
            <span>汇聚全球精英</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-chat-dot-round"></i>
            <span>共话天文前沿</span>
          </div>
        </div>
      </div>

      <div class="login-right">
        <div class="login-form-container">
          <h2>欢迎登录</h2>
          <p class="login-subtitle">登录您的账号，参与学术盛会</p>

          <el-form 
            ref="loginForm" 
            :model="loginForm" 
            :rules="loginRules"
            class="login-form"
          >
            <el-form-item prop="email">
              <el-input 
                v-model="loginForm.email" 
                prefix-icon="el-icon-message"
                placeholder="请输入邮箱"
                size="large"
              ></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input 
                type="password" 
                v-model="loginForm.password" 
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                size="large"
                show-password
                @keyup.enter.native="handleLogin"
              ></el-input>
            </el-form-item>

            <div class="form-options">
              <el-checkbox v-model="rememberMe">记住我</el-checkbox>
              <!-- <a href="javascript:;" class="forgot-link">忘记密码？</a> -->
            </div>

            <el-form-item>
              <el-button 
                type="primary" 
                :loading="loading" 
                @click="handleLogin"
                class="login-btn"
              >
                登 录
              </el-button>
            </el-form-item>
          </el-form>

          <div class="login-footer">
            <span>还没有账号？</span>
            <router-link to="/register">立即注册</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from '@/api'
import { setUserInfo } from '@/utils'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      rememberMe: false,
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        try {
          const res = await userApi.login(this.loginForm)
          
          // 保存token和用户信息
          localStorage.setItem('token', res.data.token)
          setUserInfo(res.data.userinfo)
          
          // 通知导航栏更新登录状态
          this.$bus.$emit('login-state-change')
          
          this.$message.success('登录成功')
          
          // 跳转
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        } catch (error) {
          console.error('登录失败:', error)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0d1642 0%, #1a237e 100%);
  padding: 20px;
}

.login-container {
  display: flex;
  width: 100%;
  max-width: 1000px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.login-left {
  flex: 1;
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 50%, #7c4dff 100%);
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.3), transparent),
      radial-gradient(1px 1px at 60px 80px, rgba(255,255,255,0.4), transparent),
      radial-gradient(2px 2px at 100px 50px, rgba(255,255,255,0.2), transparent),
      radial-gradient(1px 1px at 140px 120px, rgba(255,255,255,0.5), transparent);
    background-size: 150px 150px;
  }
}

.login-brand {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 60px;

  .brand-icon {
    width: 80px;
    height: 80px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;

    i {
      font-size: 40px;
      color: #ffd700;
    }
  }

  h1 {
    color: #fff;
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
  }
}

.login-features {
  position: relative;
  z-index: 1;

  .feature-item {
    display: flex;
    align-items: center;
    gap: 16px;
    color: rgba(255, 255, 255, 0.9);
    padding: 16px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
    }

    i {
      font-size: 24px;
      color: #ffd700;
    }

    span {
      font-size: 16px;
    }
  }
}

.login-right {
  flex: 1;
  padding: 60px 50px;
  display: flex;
  align-items: center;
}

.login-form-container {
  width: 100%;

  h2 {
    font-size: 32px;
    color: #1a237e;
    margin-bottom: 8px;
  }

  .login-subtitle {
    color: #666;
    margin-bottom: 40px;
  }
}

.login-form {
  .el-form-item {
    margin-bottom: 24px;
  }

  ::v-deep .el-input__inner {
    height: 50px;
    border-radius: 8px;
  }
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .forgot-link {
    color: #7c4dff;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.login-btn {
  width: 100%;
  height: 50px;
  font-size: 18px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
  border: none;

  &:hover {
    background: linear-gradient(135deg, #3949ab 0%, #7c4dff 100%);
  }
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  color: #666;

  a {
    color: #1a237e;
    font-weight: 600;
    text-decoration: none;
    margin-left: 8px;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .login-left {
    padding: 40px 30px;
  }

  .login-right {
    padding: 40px 30px;
  }

  .login-brand {
    margin-bottom: 30px;

    h1 {
      font-size: 22px;
    }
  }

  .login-features {
    display: none;
  }
}
</style>
